<template>
  <v-select
    class="octadesk-default-select"
    :options="options"
    label="label"
    :placeholder="placeholder"
    @input="handleSelect"
  >
    <template #selected-option="option">
      <span v-html="$sanitizeHtml(option.label)" />
    </template>

    <template v-slot:option="option">
      <span v-html="$sanitizeHtml(option.label)" />
    </template>
  </v-select>
</template>

<script>
  import vSelect from 'vue-select'

  export default {
    components: {
      'v-select': vSelect
    },
    props: {
      options: {
        type: Array,
        required: true
      },
      placeholder: {
        type: String,
        required: false,
        default: ''
      }
    },
    methods: {
      handleSelect(selected) {
        this.$emit('selected', selected)
      }
    }
  }
</script>

<style lang="scss">
  div.v-select.octadesk-default-select {
    border: none;
    width: 80%;
    position: relative;
    display: inline-block;
    div.vs__dropdown-toggle {
      border: none;
      height: 50px;
      padding: 0px;
      position: relative;
      z-index: 2;
      border: 1px solid #7d8f9c;
      border-radius: 5px;
      background-color: #fff;
      div.vs__actions {
        padding: 0px 13px 0 3px;
        cursor: pointer;
      }
      div.vs__actions,
      div.vs__selected-options {
        cursor: pointer;
      }
      div.vs__selected-options {
        span,
        input {
          width: 100%;
          font: normal 14px Arial, Helvetica, sans-serif;
          color: #666;
          opacity: 1;
        }
        span {
          text-align: center;
          padding: 0px;
          margin: 0px;
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
        }
        i {
          font-style: italic;
        }
        p {
          margin-top: 0px;
          &:last-child {
            margin-bottom: 0px;
          }
        }
        input {
          pointer-events: none;
          position: absolute;
          margin: 0;
          height: 100%;
        }
      }
    }
    ul.vs__dropdown-menu {
      margin-top: 0px;
      width: 100%;
      padding: 0px 0px 10px 0px;
      z-index: 1;
      border-radius: 0px 0px 10px 10px;
      position: relative;
      top: 0px;
      height: 0px;
      transition: height 0.5s;
      li.vs__dropdown-option {
        position: relative;
        z-index: 1;
        transition: 0.5s;
        font: normal 14px Arial, Helvetica, sans-serif;
        color: #666;
        margin: 0px;
        padding: 16px 20px;
        text-align: center;
        border: 1px solid #7d8f9c;
        margin-bottom: -1px;
        background-color: transparent !important;
        i {
          font-style: italic;
        }
        p {
          margin-top: 0px;
          &:last-child {
            margin-bottom: 0px;
          }
        }
        &:hover {
          z-index: 2;
          border-color: #0062f9;
        }
        &.vs__dropdown-option--selected {
          color: var(--button-active-color);
          font-weight: bold;
          background-color: var(--button-active-bg) !important;
        }
      }
    }
    &.vs--open {
      z-index: 4;
      div.vs__dropdown-toggle {
        width: 100%;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
      }
      ul.vs__dropdown-menu {
        height: 200px;
      }
    }
  }
</style>
